var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading || _vm.notFound}},[(!_vm.loading && _vm.notFound)?_c('not-found'):_vm._e(),_c('loading',{attrs:{"value":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }